<template>
  <transition name="modal">
    <div class="modal-mask scrollable">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h2>{{title}}</h2>
            <button class="modal-default-button btn btn-secondary" @click.prevent="$emit('close')">
              閉じる
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <button class="modal-default-button btn btn-secondary" @click.prevent="$emit('close')">
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      title: String,
    },
    data: function() {
      return {
        show: false,
      }
    },
    methods: {
      setTopMargin() {
        const modal = document.querySelector('.modal-container')
        const diff = window.innerHeight - modal.clientHeight
        if (diff > 0) {
          modal.style.top = `${diff / 2}px`;
        }
      },
    },
    beforeCreate() {
    },
    mounted() {
      document.querySelector('body').classList.add('modal-scroll-block')
      this.setTopMargin();
    },
    destroyed() {
      document.querySelector('body').classList.remove('modal-scroll-block')
    }
  }
</script>

<style>
  .modal-scroll-block {
    overflow: hidden;
  }
</style>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }
  .modal-mask.scrollable {
    height: 100%;
    min-height: 100vh;
    overflow-y: auto;
  }
  .modal-wrapper {
    vertical-align: middle;
    height: auto;
  }
  .modal-container {
    position: relative;
    width: 100%;
    max-width: 736px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }
  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }
  .modal-body {
    margin: 0;
    padding: 15px;
  }
  .modal-default-button {
    float: right;
  }
  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */
  .modal-enter {
    opacity: 0;
  }
  .modal-leave-active {
    opacity: 0;
  }
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
</style>